export default {
  path: '',
  component: {
    template: '<router-view :key="$route.fullPath" />'
  },
  meta: {
    title: '数据分析',
    navbar: 'el-icon-data-board'
  },
  children: [
    ...require('./base-data/route').default,
    ...require('./user-inviting-data/route').default
  ]
}
